import { useMemo } from 'react';
import { useTranslate } from '@refinedev/core';
import { Card } from 'antd';
import type { UserOut } from '@/api/generated/schemas';
import { IssuedLicencesPanel } from '@/components/account/IssuedLicencesPanel';

export const UserLicencesTab = ({ record }: { record: UserOut }) => {
  const t = useTranslate();
  const accountIds = useMemo(
    () =>
      Array.from(
        new Set(
          (record.profiles ?? [])
            .map((p) => p.account_id)
            .filter((v): v is number => v != null)
        )
      ),
    [record.profiles]
  );

  return (
    <Card title={t('iam.users.tabs.licences')}>
      <IssuedLicencesPanel
        accountIds={accountIds}
        invalidateIamUserId={record.id}
      />
    </Card>
  );
};
